import Cookies from '@/utils/cookie-provider'
import CookieStorage from '@/utils/cookie-storage'

const checkLocalStorage = () => {
  try {
    // Check if 'window' is defined before accessing 'localStorage'
    return typeof window !== 'undefined' && !!window.localStorage
  } catch {
    // Handle SecurityError: Some browsers or users may disable local storage,
    // which can result in a SecurityError when accessing window.localStorage.
    // Returning false to indicate that local storage is not available.
    return false
  }
}

class LocalStorage {
  isSupported = checkLocalStorage()

  getItem = (key) => {
    if (this.isSupported) {
      return localStorage.getItem(key)
    }

    return Cookies.get(key)
  }

  setItem = (key, value) => {
    if (this.isSupported) {
      return window.localStorage.setItem(key, value)
    }

    return Cookies.set(key, value, CookieStorage.getCookieAttributes(window))
  }

  removeItem = (key) => {
    if (this.isSupported) {
      return window.localStorage.removeItem(key)
    }

    return Cookies.remove(key, CookieStorage.getCookieAttributes(window))
  }
}

window.storage = new LocalStorage()

export { checkLocalStorage }
